import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { DateRequest } from "./DateRequest";
import { BTBusHistorySelectorBusRequest } from "./BTBusHistorySelectorBusRequest";
import { BTBusHistorySelectorStudentRequest } from "./BTBusHistorySelectorStudentRequest";
import { BTBusGetPersonPhotosRequest } from "./BTBusGetPersonPhotosRequest";

@Injectable()
export class DataService_BusTrackerBusHistory {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	BusMapPreferenceSelect(PersonID) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusMapPreferenceSelect?PersonID=" + PersonID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusHistorySelectList(parms: DateRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusHistorySelectList";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GeoFenceSelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/GeoFenceSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusHistoryFullInfoSelectList(parms: DateRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusHistoryFullInfoSelectList";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusHistorySelectorBusModeSelectList(parms: BTBusHistorySelectorBusRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusHistorySelectorBusModeSelectList";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusHistorySelectorStudentModeSelectList(parms: BTBusHistorySelectorStudentRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusHistorySelectorStudentModeSelectList";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusTrackerMapSoundsSelect() {
		var postResult$ = new Subject();
		var url = "BusTracker/BusTrackerMapSoundsSelect?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PersonGetImage(PersonID) {
		var postResult$ = new Subject();
		var url = "BusTracker/PersonGetImage?PersonID=" + PersonID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusGetPersonPhotos(parms: BTBusGetPersonPhotosRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusGetPersonPhotos";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
